export const TRANSLATION_KEYS = {
    Heading: "ticketDetailsPage.updateDialog.heading",
    SecondaryHeading: "ticketDetailsPage.updateDialog.secondaryHeading",
    ConfirmText: "common.continueText",
    DismissText: "common.dismissText"
};